export default function isSamsungBuiltinBrowser() {
    const samsungS3ModelNames = [
        'GT-I9300', 'SHV-E210K', 'SGH-T999', 'SGH-I747', 'SGH-N064', 'SC-06D',
        'SCH-R530', 'SCH-I535', 'SPH-L710', 'GT-I9305', 'GT-I9308',
    ];
    let isSamsungS3 = false;
    samsungS3ModelNames.forEach(name => {
        if (navigator.userAgent.match(name)) {
            isSamsungS3 = true;
        }
    });
    const isBuiltInBrowser = navigator.userAgent.match('Version/4.0');
    return (isSamsungS3 && isBuiltInBrowser);
}


// WEBPACK FOOTER //
// ./src/lib/isSamsungBuiltinBrowser.js